import { render } from "./WeekCalendar.vue?vue&type=template&id=482af2a0&scoped=true"
import script from "./WeekCalendar.vue?vue&type=script&lang=js"
export * from "./WeekCalendar.vue?vue&type=script&lang=js"

import "./WeekCalendar.vue?vue&type=style&index=0&id=482af2a0&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\klegrand-ext\\Documents\\intratoneinfov4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-482af2a0"]])

export default __exports__